import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Login from "./Login/Login";
import RegisterForm from "./Register/RegisterForm";
import { colors, navbar, home } from "../styles/theme";

const AuthModal = ({ defaultMode = "login" }) => {
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState(defaultMode);

  const handleShow = () => {
    setMode(defaultMode);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  // 🔥 Dynamic button style + text
  const isLogin = defaultMode === "login";

  const buttonStyle = isLogin
    ? {
        ...navbar.loginButton,
        border: `1px solid ${colors.sidebarBg}`,
        color: colors.sidebarBg,
        backgroundColor: "transparent",
      }
    : {
        ...home.heroButton,
        border: "0px solid",
        cursor: "pointer",
        textAlign: "center",
      };

  const buttonText = isLogin ? "Login" : "Get Started";

  return (
    <>
      {/* Dynamic Button */}
      <button onClick={handleShow} style={buttonStyle}>
        {buttonText}
      </button>

      <Modal show={show} onHide={handleClose} centered size="sm">
        <Modal.Header closeButton>
          <Modal.Title>
            {mode === "login" ? "" : "Create Account"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {mode === "login" ? (
            <Login
              closeModal={handleClose}
              switchToRegister={() => setMode("register")}
            />
          ) : (
            <RegisterForm
              onRegisterSuccess={handleClose}
              switchToLogin={() => setMode("login")}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AuthModal;